import styled from '@emotion/styled';
import { Widget } from '../../../apiService';
import { headerHeight } from '../../../Header';
import Slider from '../../../Slider';
import { SliderImagePreload } from '../../../SliderItem';

const sliderRatio = 9 / 16;
const bottomOffsetPercentage = {
  sm: 16,
  md: 26,
  xl: 30,
};

// At the top of the page the slider goes under the fixed, transparent header by cancelling Layout's
// top gutter, like the compact teaser (see TeaserVideo). marginBottom sets the gap to the next row on
// its own (that row drops its top margin, see `afterSlider` in WidgetManager); on sm+ it is negative,
// pulling the row up onto the slider.
const SliderWrapper = styled.div<{ atPageTop?: boolean }>(({ theme, atPageTop }) => ({
  ...(atPageTop ? { marginTop: `calc(-1 * (${headerHeight} + ${theme.spacing(3)}))` } : undefined),
  marginBottom: `calc(${theme.spacing(8)} + ${theme.spacing(3)})`,
  ...theme.mixins.create(bottomOffsetPercentage, (b) => ({ marginBottom: `calc(${theme.spacing(3)} - ${b * sliderRatio}%)` })),
}));

type MainSliderWidgetProps = { widget: Widget<'main_slider'>; atPageTop?: boolean; serverTime?: string };

const MainSliderWidget = ({ widget, atPageTop, serverTime }: MainSliderWidgetProps) => {
  const items = widget.configuration?.items;
  if (!items?.length) return null;

  const [{ image_path, mobile_image_path }] = items;

  return (
    <SliderWrapper atPageTop={atPageTop}>
      <SliderImagePreload images={{ desktop: image_path, mobile: mobile_image_path }} />
      <Slider items={items} serverTime={serverTime} />
    </SliderWrapper>
  );
};

export default MainSliderWidget;
